// Public pixel ID already installed in index.html. Never put an access token here.
export const META_PIXEL_ID = '4516728901945855';
const completedPlans = new Set();
let lastPath;

export function metaEnvironment() {
  return process.env.NODE_ENV === 'development' || ['dev', 'development', 'test', 'staging'].includes(process.env.REACT_APP_ENV)
    ? 'development' : 'production';
}

export function trackMetaEvent(name, parameters = {}, custom = false, eventId) {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return false;
    const environment = metaEnvironment();
    const development = environment === 'development';
    const args = [development || custom ? 'trackCustom' : 'track',
      development ? `${name}_dev` : name, { ...parameters, environment }];
    if (eventId) args.push({ eventID: eventId });
    window.fbq(...args);
    return true;
  } catch {
    // Advertising must never interrupt signup or onboarding.
    return false;
  }
}

const PUBLIC_PAGES = {
  '/': 'Landing page', '/pricing': 'Pricing', '/signup': 'Signup',
  '/demo': 'Demo', '/help': 'FAQ', '/privacy-policy': 'Privacy policy',
};

export function trackMetaPage(pathname) {
  // Ignore private routes and token-bearing URL paths. Do not send user data.
  const path = pathname.replace(/\/+$/, '') || '/';
  if (lastPath === path) return;
  lastPath = path;
  if (!PUBLIC_PAGES[path]) return;
  if (!trackMetaEvent('PageView', { page_name: PUBLIC_PAGES[path] })) {
    lastPath = undefined;
    return;
  }
  if (path === '/pricing') {
    trackMetaEvent('ViewContent', { content_name: 'Pricing', content_category: 'Plans' });
  }
}

export function trackMetaOnboardingCompletion(previous, current) {
  if (!previous?.id || previous.id !== current?.id || !previous.status
      || previous.status === 'completed' || current.status !== 'completed'
      || completedPlans.has(current.id)) return;
  const key = `sayable-meta-completed:${metaEnvironment()}:${META_PIXEL_ID}:${current.id}`;
  try {
    if (window.localStorage.getItem(key)) return;
  } catch { /* In-memory protection still works without storage. */ }
  let eventId;
  try { eventId = window.crypto.randomUUID(); } catch { return; }
  if (!trackMetaEvent('CompleteRegistration', { status: true, content_name: 'Onboarding completed' }, false, eventId)) return;
  completedPlans.add(current.id);
  try { window.localStorage.setItem(key, eventId); } catch { /* Optional persistence. */ }
}
